import PropTypes from 'prop-types';
import React from 'react';
import StepProgressBar from './StepProgressBar';
import DraftStepStore from '../stores/DraftStepStore';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { intlShape } from 'react-intl';
import { transitionToStep } from '../actions/designBriefActions'

class BriefHeader extends React.Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.currentStep !== this.props.currentStep;
    }

    transitionToStep(step) {
        this.context.executeAction(transitionToStep, step);
    }

    translatedSteps() {
        const {formatMessage} = this.context.intl;

        let steps = {}
        this.props.steps.forEach((step) => {
            steps[step] = formatMessage({id: `steps.${step}`});
        });

        return steps;
    }

    renderProgressBar() {
        const { currentStep } = this.props;

        return (
            <div className="row">
                <div className="column">
                    <div className="brief-header__progress">
                        <StepProgressBar
                            steps={this.translatedSteps()}
                            currentStep={currentStep}
                            onClickStep={this.transitionToStep.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { formatMessage } = this.context.intl;

        return (
            <div className="brief-header">
                <div className="brief-header__inner row">
                    <div className="column">
                        <h1 className="brief-header__inner__heading">
                            {formatMessage({id: this.props.header})}
                        </h1>
                        <p className="brief-header__inner__sub-heading">
                            {formatMessage({id: this.props.subHeader})}
                        </p>
                    </div>
                </div>

                {this.renderProgressBar()}
            </div>
        );
    }
}

BriefHeader.propTypes = {
    steps: PropTypes.array.isRequired,
};

BriefHeader.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
    intl: intlShape.isRequired,
};

export default connectToStores(BriefHeader, [DraftStepStore], (context, props) => {
    const store = context.getStore(DraftStepStore);

    return {
        steps: store.getSteps(),
        currentStep: store.getCurrentStep().id,
        header: store.getCurrentStep().header,
        subHeader: store.getCurrentStep().paragraph,
    };
});



// WEBPACK FOOTER //
// ./js/launch/components/BriefHeader.jsx